import * as React from 'react';
import { Bem, addClass } from '../../utils/css.js';
import '../../constants.js';
import { HeaderBrand } from './HeaderBrand.js';
import { HeaderTime } from './HeaderTime.js';
import { HeaderItem } from './HeaderItem.js';
import { HeaderMenu } from './HeaderMenu.js';
import { HeaderMenuGroup } from './HeaderMenuGroup.js';
import { HeaderMenuItem } from './HeaderMenuItem.js';
import { HeaderMenuItemSeparator } from './HeaderMenuItemSeparator.js';
import { useId } from '../../utils/hooks/useId.js';
import './Header.scss.js';

const bem = Bem.create("vai-header");
function Header(props) {
  const { children, htmlId, htmlTitle, time, timeDetails, title, logoVisible, hasNavigation, displayShadow, dataTa, className, animated, ...rest } = props;
  const id = useId(htmlId, ["header"]);
  const headerClasses = addClass(bem.block(displayShadow && "shadow", animated && "animated", hasNavigation && "with-navigation"), className);
  return /* @__PURE__ */ React.createElement("header", {
    id: id.toString(),
    "data-ta": dataTa,
    className: headerClasses,
    title: htmlTitle,
    ...rest
  }, /* @__PURE__ */ React.createElement(HeaderBrand, {
    animated,
    visible: logoVisible
  }), time && /* @__PURE__ */ React.createElement(HeaderTime, {
    htmlId: id.toHtmlId(),
    time,
    details: timeDetails,
    dataTa: "vai-header-time"
  }), /* @__PURE__ */ React.createElement("h1", {
    id: id.copyWith(["title"]).toString(),
    className: bem.element("title")(),
    "data-ta": "vai-header-title"
  }, title), /* @__PURE__ */ React.createElement("div", {
    id: id.copyWith(["action-container"]).toString(),
    className: bem.element("children")()
  }, children));
}
Header.defaultProps = {
  dataTa: "vai-header",
  animated: true,
  hasNavigation: true
};
Header.Item = HeaderItem;
Header.Menu = HeaderMenu;
Header.MenuItem = HeaderMenuItem;
Header.MenuGroup = HeaderMenuGroup;
Header.MenuItemSeparator = HeaderMenuItemSeparator;

export { Header };
